import Swiper from 'swiper/bundle';

if ($(".slider-type-3.swiper-container").length > 0) {
    const slider_type_3_swiper = new Swiper(".slider-type-3.swiper-container", {
        slidesPerView: 'auto',
        loop: true,
        speed: 1000,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        navigation: {
            nextEl: ".section-slider-type-3 .swiper-button-next.slider-type-3-swiper-button",
            prevEl: ".section-slider-type-3 .swiper-button-prev.slider-type-3-swiper-button",
        }
    });
}